import {DG_axiosNormal} from "../../axios/normal";

const BASE_URL_UPLOAD =
    `/dogoo/files-manager-rest/v2.0/files/`;

export async function getPreviewApi(fileId) {
    const response = await DG_axiosNormal.get(`${BASE_URL_UPLOAD}${fileId}/preview`);
    return response?.data || []
}